import { createSlice } from "@reduxjs/toolkit";
import {
  fetchItemsList,
  fetchItemCategories,
  fetchItemRacks,
  fetchItemModels,
  fetchItemOrigins,
  fetchItemUnits,
  createOrUpdateItem,
  deleteItem,
  fetchBranchList,
  fetchItemCode,
  fetchItemGroups,
  importItems,
  fetchDistributors,
  fetchManufactures,
  fetchGenericNames
} from "./itemManageThunks";

const itemManageSlice = createSlice({
  name: "itemManage",
  initialState: {
    items: [],
    itemCode: "",
    groups: [],
    models: [],
    origins: [],
    categories: [],
    racks: [],
    taxAccs: [],
    units: [],
    genericNames: [],
    batches: [],
    BranchFeildNameid: [],
    branches: [],
    distributors:[],
    manufactures: [],
    selectedItem: null,
    isEditItem: false,
    loading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    resetItemManageStatus: (state) => {
      state.successMessage = null;
      state.error = null;
    },
    setSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
    },
    setIsEditItem: (state, action) => {
      state.isEditItem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Items
      .addCase(fetchItemsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchItemsList.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchItemsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
.addCase(fetchGenericNames.fulfilled, (state, action) => {
  state.genericNames = action.payload;
})
      .addCase(fetchItemCode.fulfilled, (state, action) => {
        state.itemCode = action.payload;
      })

      // Categories
      .addCase(fetchItemCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
      })

      // Racks
      .addCase(fetchItemRacks.fulfilled, (state, action) => {
        state.racks = action.payload;
      })

      // Models
      .addCase(fetchItemModels.fulfilled, (state, action) => {
        state.models = action.payload;
      })

      //Groups
      .addCase(fetchItemGroups.fulfilled, (state, action) => {
        state.groups = action.payload;
      })
      // Origins
      .addCase(fetchItemOrigins.fulfilled, (state, action) => {
        state.origins = action.payload;
      })

      // Units
      .addCase(fetchItemUnits.fulfilled, (state, action) => {
        state.units = action.payload;
      })

      // Branches
      .addCase(fetchBranchList.fulfilled, (state, action) => {
        state.branches = action.payload;
      })

      // Create/Update Item
      .addCase(createOrUpdateItem.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })

      // Delete Item
      .addCase(deleteItem.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })

     .addCase(fetchDistributors.fulfilled, (state, action) => {
        state.distributors = action.payload;
      })

     .addCase(fetchManufactures.fulfilled, (state, action) => {
        state.manufactures = action.payload;
      })

      // Import Items
      .addCase(importItems.pending, (state) => {
        state.loading = true;
      })
      .addCase(importItems.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message || "Items imported successfully";
      })
      .addCase(importItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to import items";
      })

  },
});

export const {
  resetItemManageStatus,
  setSelectedItem,
  setIsEditItem,
} = itemManageSlice.actions;

export default itemManageSlice.reducer;
